import iframeResize from '@iframe-resizer/parent';
import { Component } from '@opten/gin-tonic/helpers/compiler';

const CHILD_TIMEOUT = 2000;

@Component({ className: 'js-iframe' })
export class IframeComponent {
	constructor(private element: HTMLElement) {
		let childReady = false;

		const customHeightHandler = (e: MessageEvent) => {
			if (e.origin !== 'https://controlling.displayactive.ch') return;

			const d = e.data;

			if (d && d.type === 'da-form-height' && d.height) {
				this.element.style.height = d.height + 'px';
			}
		};
		window.addEventListener('message', customHeightHandler);

		iframeResize(
			{
				license: 'GPLv3',
				warningTimeout: CHILD_TIMEOUT,
				onReady: () => {
					childReady = true;
				},
			},
			this.element
		);

		setTimeout(() => {
			if (childReady) {
				window.removeEventListener('message', customHeightHandler);
				return;
			}
		}, CHILD_TIMEOUT);
	}
}
